import React, { Component } from 'react'
import MyFrame from '../components/Frame'
import { Switch, Route, Redirect } from 'react-router-dom'
import DonationAdd from "./donation/DonationAdd"
import DonationQuery from "./donation/DonationQuery"
import '../css/donation.css'
import { app } from "../app"
import DonationMy from "./donation/DonationMy"
import DonationSign from "./donation/DonationSign"

function checkMenu (path) {
    let key = '1'
    switch (path) {
        case '/donation/add':
            key = '1'
            break
        case '/donation/query':
            key = '2'
            break
        case '/donation/my':
            key = '3'
            break
        case '/donation/sign':
            key = '4'
            break
    }
    return key
}

class Donation extends Component {
    constructor (props) {
        super(props)
        this.state = {
            menu_key: checkMenu(props.location.pathname),
        }
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    setData = (data) => app.setStateSync(this, data)

    componentWillReceiveProps (nextProps) {
        if (this.props.location.pathname !== nextProps.location.pathname) {
            this.setData({ menu_key: checkMenu(nextProps.location.pathname) })
        }
    }

    render () {
        let { menu_key } = this.state,
            token = app.getToken(),
            menuList = [
                { key: '1', text: '我要捐赠', link: '/donation/add' },
                { key: '2', text: '查看捐赠', link: '/donation/query' },
            ]
        if (token) {
            menuList.push({ key: '3', text: '我的捐赠', link: '/donation/my' }, {
                key: '4',
                text: '捐赠物品签收',
                link: '/donation/sign'
            })
        }
        return (
            <MyFrame className="grade" history={this.props.history} menuList={menuList} menuSelectKey={menu_key}>
                <Switch>
                    <Route exact path="/donation/add" component={DonationAdd}/>
                    <Route exact path="/donation/query" component={DonationQuery}/>
                    {
                        token ? [
                            <Route exact key="1" path="/donation/my" component={DonationMy}/>,
                            <Route exact key="2" path="/donation/sign" component={DonationSign}/>,
                        ] : null
                    }
                    <Route render={() => <Redirect to="/donation/add"/>}/>
                </Switch>
            </MyFrame>
        )
    }
}

export default Donation



// WEBPACK FOOTER //
// ./src/routes/Donation.jsx